import axios from "axios";

export const getModalitaPagamentoApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/modalita/`, {
        params: params
    });
}

export const getModalitaPagamentoByIdApi = (idModalita, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/modalita/${idModalita}`, {
        params: params
    });
}

export const aggiornaModalitaPagamentoApi = (idModalita, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/modalita/${idModalita}`, payload, {
        params: params
    });
}

export const aggiungiModalitaPagamentoApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/modalita/`, payload, {
        params: params
    });
}

export const deleteModalitaPagamentoApi = (idModalita, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/modalita/${idModalita}`, {
        params: params
    });
}

export const getQuoteApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/`, {
        params: params
    });
}

export const attivaQuotaByIdApi = (idQuota, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuota}/attiva/`, payload, {
        params: params
    });
}

export const attivaQuotaVeicoloByIdApi = (idQuota, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuota}/veicolo/attiva/`, payload, {
        params: params
    });
}

export const deleteQuotaApi = (idQuota, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuota}`, {
        params: params
    });
}

export const getQuotaVeicoloByIdApi = (idQuotaVeicolo, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/veicolo/${idQuotaVeicolo}`, {
        params: params
    });
}

export const getQuotaByIdApi = (idQuota, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuota}`, {
        params: params
    });
}

export const deleteQuotaVeicoloApi = (idQuotaVeicolo, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuotaVeicolo}/veicolo/`, {
        params: params
    });
}

export const deleteQuotaUtenteApi = (idQuota, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuota}`, {
        params: params
    });
}

export const getTipiVersamentoApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/tipi-versamento/`, {
        params: params
    });
}

export const getDocumentoQuotaByIdApi = (idQuota, idDocumento, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuota}/documento/${idDocumento}`, {
        params: params
    });
}

export const deleteDocumentoQuotaApi = (idQuota, idDocumento, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuota}/documento/${idDocumento}`, {
        params: params
    });
}

export const getTransazioniApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/transazione/`, {
        params: params
    });
}

export const getModuloQuotaByTipoApi = (tipoModulo, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/modulo/${tipoModulo}`, {
        params: params
    });
}